<template lang="pug">
window(
  :title="$t('walk_setting')",
  :zGroup=1,
  :isOpen.sync="module.showWalkSetting",
  :closeButton="true",
  positionHint="center"
)
  dl
    dt {{ $t('duration') }}: {{ module.config.walk.duration / 1000 }}s
    dd
      input(
        type="range",
        min=0,
        max=10000,
        step="1",
        v-model.number="module.config.walk.duration"
      )
    dt {{ $t('wait') }}: {{ module.config.walk.wait / 1000 }}s
    dd
      input(
        type="range",
        min=0,
        max=10000,
        step="1",
        v-model.number="module.config.walk.wait"
      )
  ul
    li
      | {{ $t('easing') }}:
      select(v-model="module.config.walk.easing")
        option(v-for="o in easings") {{ o }}
    li
      label
        input(type="checkbox", v-model="module.config.walk.keepFovy")
        | {{ $t('keep_fov') }}
    li
      label
        input(type="checkbox", v-model="module.config.walk.loop")
        | {{ $t('loop') }}
</template>


<i18n>
en:
  walk_setting: Walk Setting
  duration: Duration
  wait: Wait
  easing: easing
  keep_fov: Keep FOV
  loop: Loop
ja:
  walk_setting: 巡回設定
  duration: 移動時間
  wait: 静止時間
  easing: easing
  keep_fov: 画角を保持
  loop: ループ
</i18n>


<script lang="ts">
import Vue from "vue"
import * as easing from "@hscmap/easing"

export default Vue.extend({
  props: {
    module: { required: true },
  },
  computed: {
    easings() {
      return Object.keys(easing)
    },
  },
})
</script>


<style lang="scss" scoped>
ul {
  list-style: none;
  padding: 0;
}
li {
  margin-bottom: 1em;
}
</style>
